import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'
import request, { del, get, post, put, upload } from './utils/request'
import './styles/base.css'

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.prototype.$request = request
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put
Vue.prototype.$delete = del
Vue.prototype.$upload = upload

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
